import {FC, useState, createContext, useContext} from 'react'
// import {
//   QueryState,
//   QueryRequestContextProps,
//   initialQueryRequest,
// } from '../../../../../../_metronic/helpers'
// import {companyInitialSortQueryState} from "./_models";
import { QueryRequestContextProps, QueryState, initialQueryRequest } from '../../../../_metronic/helpers';
export const HOME_PAGE_CONTEXT_KEY = 'HOME_PAGE_CONTEXT'

const HomeRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const HomeRequestProvider: FC<{children: any}> = ({children}) => {
  const homeContext = localStorage.getItem(HOME_PAGE_CONTEXT_KEY)
  let hpdc: any = {}
  if (homeContext) {
    hpdc = JSON.parse(homeContext)
  }
  const [state, setState] = useState<QueryState>({
    Keyword: '', 
    Sortn: 'LastModificationDate',
    Order: 'asc',
    ...hpdc,
  })

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
    localStorage.setItem(HOME_PAGE_CONTEXT_KEY, JSON.stringify(updatedState))
  }

  return (
    <HomeRequestContext.Provider value={{state, updateState}}>
      {children}
    </HomeRequestContext.Provider>
  )
}

const useHomeQueryRequest = () => useContext(HomeRequestContext)
export {HomeRequestProvider, useHomeQueryRequest}